import { Form, Modal } from "antd";

import { Input } from "antd";
import { useFormik } from "formik";
import * as Yup from "yup";

interface SaveCompanyNameModalProps {
    visible: boolean;
    onCancel: () => void;
    onSave: (companyName: string) => void;
}

export const SaveCompanyNameModal: React.FC<SaveCompanyNameModalProps> = ({ visible, onCancel, onSave }) => {

    const handleSubmit = (values: { companyName: string }) => {
        onSave(values.companyName);
        onCancel();
    };

    const formik = useFormik({
        initialValues: {
            companyName: ''
        },
        validationSchema: Yup.object({
            companyName: Yup.string().test(
                'valid-company-name',
                'Please enter a valid company name',
                (value: string | null) => {
                    if (!value) return true;
                    return /[a-zA-Z0-9]/.test(value);
                }
            ).required('Company name is required')
        }),
        onSubmit: handleSubmit
    });

    return (
        <Modal
            title="Save company name before starting the research"
            open={visible}
            onCancel={onCancel}
            onOk={() => formik.handleSubmit()}
            okText="Save"
            cancelText="Cancel"
        >
            <Form layout="vertical">
                <Form.Item label="Company name*:" validateStatus={formik.errors.companyName && formik.touched.companyName ? 'error' : ''} help={formik.errors.companyName && formik.touched.companyName ? formik.errors.companyName.toString() : ''}>
                    <Input value={formik.values.companyName} onChange={e => formik.setFieldValue('companyName', e.target.value)} />
                </Form.Item>
            </Form>
        </Modal>
    );
};